import { render, staticRenderFns } from "./TableBarang.vue?vue&type=template&id=6276948c"
import script from "./TableBarang.vue?vue&type=script&lang=js"
export * from "./TableBarang.vue?vue&type=script&lang=js"
import style0 from "./TableBarang.vue?vue&type=style&index=0&id=6276948c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports